module.exports = __webpack_public_path__ + "img/sidekix-media-lrk0l9w8rI0-unsplash.9d1d61db.jpg";